/**
 * Feature Flags Configuration
 * Enable/disable modules per client deployment
 *
 * Configurable per deployment
 */

const features = {
  // Client Information
  client: {
    name: "Voxxil HIS",
    shortName: "Voxxil",
    subtitle: "Health Information System",
    logo: "/logo.svg",
    primaryColor: "#1976d2",
    accentColor: "#dc004e",
  },

  // Core Modules (always enabled)
  core: {
    patientManagement: true,
    userManagement: true,
    authentication: true,
    profile: true,
  },

  // PACS & Imaging
  imaging: {
    enabled: true,
    dicomViewer: true,
    viewerType: "ohif", // "ohif" | "stone" | "dwv"
    studyList: true,
    reporting: true,
  },

  // Scheduling & Appointments
  scheduling: {
    enabled: true,
    calendar: true,
    appointmentReminders: true,
  },

  // Billing & Invoicing
  billing: {
    enabled: true,
    invoiceGeneration: true,
    paymentTracking: true,
  },

  // Referrals
  referrals: {
    enabled: true, // Enable external referrals
    incomingReferrals: true,
    outgoingReferrals: true,
  },

  // Multi-branch Support
  branches: {
    enabled: false, // Single location
    branchSwitching: false,
  },

  // Analytics & Reporting
  analytics: {
    enabled: true,
    dashboardStats: true,
    reportExport: true,
  },

  // Procedure Tracking
  procedureTracking: {
    enabled: true,
    workflowStatus: true,
  },

  // Patient Portal
  patientPortal: {
    enabled: true,
    viewReports: true,
    viewImages: false, // Reports only for patients
    downloadPDF: true,
    shareResults: false,
  },

  // Advanced Features
  advanced: {
    dictation: true, // Medical dictation enabled
    templates: true, // Custom report templates
    signatures: true, // Digital signatures
    auditLog: true,
  },

  // Laboratory Information System
  laboratory: {
    enabled: true,
    testOrdering: true,
    specimenTracking: true,
    resultEntry: true,
    qualityControl: true,
    analyzerInterface: true,
    inventoryManagement: true,
    labReporting: true,
    labAnalytics: true,
    equipmentManagement: true,
    reflexTesting: true,
    deltaChecks: true,
    criticalValueAlerts: true,
    patientPortalResults: true,
  },

  // Modality Configuration
  modalities: {
    allowedTypes: ["US", "CR", "DX", "MR", "CT"],
    modalityNames: {
      US: "Ultrasound",
      CR: "Computed Radiography",
      DX: "Digital Radiography",
      MR: "MRI",
      CT: "CT Scan",
    },
  },
};

export default features;

// Helper functions
export const isFeatureEnabled = (path) => {
  const keys = path.split(".");
  let value = features;
  for (const key of keys) {
    if (value[key] === undefined) return false;
    value = value[key];
  }
  return value === true;
};

export const getFeatureConfig = (path) => {
  const keys = path.split(".");
  let value = features;
  for (const key of keys) {
    if (value[key] === undefined) return null;
    value = value[key];
  }
  return value;
};
